import { s_star, s_star_empty, s_star_half } from '@fiverr-private/fit/icons';

/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASS = 'orca-star';

/**
 * All available star themes.
 * @type {Object<String>}
 */
export const THEMES = {
    EMPTY: 'empty',
    HALF: 'half',
    FULL: 'full'
};

/**
 * Star sizes in pixels
 * @type {Number}
 */
export const STAR_SIZE = 15;

/**
 * Mapping between a theme and its matching icon
 * @type {Object<Function>}
 */
export const STAR_ICON_CONFIG = {
    [THEMES.EMPTY]: s_star_empty,
    [THEMES.HALF]: s_star_half,
    [THEMES.FULL]: s_star
};
